// export  const baseUrl = "https://tapi.vjoinlife.com"; 

// export    const meeting_url = "https://tv.vjoinlife.com/"; 
//dev 


export  const baseUrl = "https://m.vjoinlife.com/api/"; 

export    const meeting_url = "https://v.vjoinlife.com/";

